import { combineReducers } from '@reduxjs/toolkit'

import { audienceTiktokSlice } from './audienceTiktokSlice'
import { tiktokCampaignSlice } from './tiktokCampaign'

export const scheduleProcess = combineReducers({
  audienceTiktok: audienceTiktokSlice.reducer,
  tiktok: tiktokCampaignSlice.reducer,
})
